import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { commentCloseCommentBlockModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { CommentBlockForm } from './components'
// styles
import { styles } from './styles'

type CommentBlockCardProps = {}

export const CommentBlockCard: FC<CommentBlockCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const commentBlockError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile
          onCloseClick={() => dispatch(commentCloseCommentBlockModal())}
        />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Block Comment" icon={icons.AlertTriangle} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Are you sure you want to block this comment?" />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <CommentBlockForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={commentBlockError} />
        </div>
      </div>
    </div>
  )
}

CommentBlockCard.propTypes = {}
